module.exports = __webpack_public_path__ + "static/img/100595.b52874d4.png";